

export default class KeyboardIterator {

    private onChange        : callback

    public currentIndex    : number | null
    private items           : any[]         = []
    private totalItems      : number        = 0

    constructor(onChange: callback, items: any[]) {

        this.onChange       = onChange
        this.currentIndex   = null;

        this.setItems(items)

    }

    public setItems(items:any[]) {
        this.items          = items
        this.totalItems     = items.length

        // assign dynamic property to each object
        _.map(items, (item:any, key) => {
            item.keyboardIteratorIndex = key
        })
    }

    // public handleKeyDown(key: string): number | null {
    //     switch (key) {
    //         case 'ArrowUp':
    //             return this.moveUp();
    //         case 'ArrowDown':
    //             return this.moveDown();
    //         default:
    //             return this.currentIndex;
    //     }
    // }

    public moveUp(): void {

        const oldValue = this.currentIndex

        // if (this.state.currentCursorKey === null) {
        //     newValue = 0
        // } else {
        //     newValue = this.state.currentCursorKey - 1
        //     if (newValue < 0) newValue = 0
        // }
        //
        // this.setState({currentCursorKey: newValue})

        if (this.currentIndex === null) {
            this.currentIndex = 0;
        } else {
            this.currentIndex = Math.max(0, this.currentIndex - 1);
        }

        // if changed
        if (this.currentIndex!==oldValue) {
            this.onChange(this.currentIndex)
        }
    }

    public moveDown(): void {

        const oldValue = this.currentIndex


        if (this.currentIndex === null) {
            this.currentIndex = 0;
        } else {
            // console.log("total=", this.totalItems)
            this.currentIndex = Math.min(this.totalItems - 1, this.currentIndex + 1);
        }

        // console.log("old=",oldValue, "currentIndex=", this.currentIndex)

        // if changed
        if (this.currentIndex!==oldValue) {
            this.onChange(this.currentIndex)
        }

    }

    public reset(): void {
        this.currentIndex = null;
    }

    public setTotalItems(total: number): void {
        this.totalItems = total;
    }

    public isSelected(item:any): boolean {
        return item.keyboardIteratorIndex === this.currentIndex
    }
}